import { Link } from "react-router-dom";
import { images } from "../../assets/img";
import { useScrollToQueryElement } from "../../hooks/useScrollToQueryElement";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { HomeSlider } from "./HomeSlider";
import { whoWeHelpItems, whyChooseUsItems } from "../../data/home";
import { useAppStore } from "../../store/useAppStore";
import { t } from "../../utils/utils";

export function Home() {
  useScrollToQueryElement(true);
  const { appLang } = useAppStore();

  return (
    <>
      <div id="homeBanner">
        <div className="bannerCont cont1">
          <div className="text1">{t.accountsInUk}</div>
          <div className="text2">{t.accountsInUkText}</div>
          <div className="text3">
            {t.weSpeak}
            <br />
            English <img className="flag" src={images.gb} alt="" /> Română&nbsp;
            <img className="flag" src={images.ro} alt="" /> Русский&nbsp;
            <img className="flag" src={images.ru} alt="" />
          </div>
        </div>
      </div>

      <div className="textBloks cont1">
        <div className="head1">{t.whoWeHelp}</div>
        <div className="textBlockCont">
          {whoWeHelpItems[appLang].map((el) => (
            <div className="item style2" key={el.title}>
              <img className="ico" src={el.icon} alt="" />
              <div className="head2">{el.title}</div>
              <div className="text1">{el.text}</div>
              <Link className="link1" to={el.link}>
                {t.viewDetails} &gt;
              </Link>
            </div>
          ))}
        </div>
      </div>

      <div className="textBloks v2">
        <div className="head1">{t.whyChooseUs}</div>
        <div className="textBlockCont">
          {whyChooseUsItems[appLang].map((el) => (
            <div className="item" key={el.title}>
              <img className="ico" src={el.icon} alt="" />
              <div className="head2">{el.title}</div>
              <div className="text1">{el.text}</div>
            </div>
          ))}
        </div>
      </div>

      <HomeSlider />
    </>
  );
}
